import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { closeFeedbackPopup, openFeedbackSentPopup, showComplaints } from '../../../../actions/feedback';
import { QuestionBlock } from './QuestionBlock';

export const QuestionBlockContainer = connect(
  undefined,
  (dispatch: Dispatch<{}>) => ({
    onYesButtonClick() {
      dispatch(closeFeedbackPopup());
      dispatch(openFeedbackSentPopup());
    },
    onNoButtonClick() { dispatch(showComplaints()); },
    onDidNotPickUpPhoneButtonClick() {
      dispatch(closeFeedbackPopup());
      dispatch(openFeedbackSentPopup());
    },
  }),
)(QuestionBlock);
